/* eslint no-new: 0 */
import Vue from 'vue';
import MyStore from '@rei/my-store';
import { getPreferredStore } from '@rei/session';
import NavButton from './components/NavButton.vue';
import MyStoreBackdrop from './components/MyStoreBackdrop.vue';
import './account';

// Sets browser state value for other elements/components to see when myStore is open
const setGlobalMyStoreOpen = (value) => localStorage.setItem('myStoreOpen', value);

const gNav = document.querySelector('.gnav');
const isWhiteNav = gNav !== null;

let isMyStoreMounted = false;

const eventBus = new Vue({});

// If it is white nav render backdrop and navbutton components
if (isWhiteNav) {
  const myStoreNavButtonData = {
    preferredStore: null,
  };

  const secondaryNav = document.querySelector('[data-js="secondary-nav"]');
  const backdrop = document.createElement('div');
  backdrop.setAttribute('id', 'my-store-backdrop');
  secondaryNav.appendChild(backdrop);

  new Vue({
    el: '#my-store-backdrop',
    render(app) {
      return app(MyStoreBackdrop);
    },
  });

  new Vue({
    el: '[data-ui="site-header-action-local"]',
    data: myStoreNavButtonData,
    mounted() {
      eventBus.$on('update-store', this.handleUpdateStore);
      eventBus.$on('suggested-store', this.handleUpdateStore);

      const cachedStore = getPreferredStore();

      if (cachedStore) {
        const {
          storeNumber, storeDisplayName, availability, isSuggestion,
        } = cachedStore;

        if (storeNumber && storeDisplayName && availability) {
          myStoreNavButtonData.preferredStore = {
            storeNumber,
            storeDisplayName,
            availability,
            isSuggestion,
          };
        }
      }
    },
    beforeDestroy() {
      eventBus.$off('update-store', this.handleUpdateStore);
      eventBus.$off('suggested-store', this.handleUpdateStore);
    },
    methods: {
      handleUpdateStore(store) {
        myStoreNavButtonData.preferredStore = store;
      },
    },
    render(app) {
      return app(NavButton, {
        props: myStoreNavButtonData,
      });
    },
  });
}

const myStoreToggleButton = document.querySelector("[data-ui='site-header-action-local']");
const navbarWrapper = document.querySelector("[data-ui='site-navigation']");

// Mount mystore and set event listeners, this function will only be executed
// if my storeToggleButton is hover or focused
// Otherwise there is no need to mount component
const mountMyStore = () => {
  isMyStoreMounted = true;

  const data = {
    open: false,
  };

  // Insert <li> element next to storeToggle button to render MyStore component
  myStoreToggleButton.parentNode.insertAdjacentHTML('afterEnd', `<li class="stores-dropdown ${isWhiteNav && 'stores-dropdown--white-nav'}"><div id="my-store-placement"></div></li>`);
  const storesDropdown = document.querySelector('.stores-dropdown');

  new Vue({
    el: '#my-store-placement',
    data,
    created() {
      // Sync with initial value before mount.
      // This avoids a scenario if user reloads with myStore open (value would remain true)
      // causing signIn Nudge not to load because open is not reset to false yet.
      setGlobalMyStoreOpen(this.open);
    },
    mounted() {
      eventBus.$on('closed', (escKey) => this.handleClose(escKey));

      myStoreToggleButton.setAttribute('aria-expanded', 'false');
      const newSpan = document.createElement('span');
      newSpan.setAttribute('class', 'sr-only');
      newSpan.setAttribute('id', 'my-store-sr-only');
      newSpan.append('Open select my store');
      myStoreToggleButton.append(newSpan);
      myStoreToggleButton.setAttribute('aria-controls', 'my-store-bar');

      myStoreToggleButton.addEventListener('click', this.toggleButtonHandler);
      window.addEventListener('click', this.clickOutsideHandler, true);
    },
    beforeDestroy() {
      eventBus.$off('closed', this.handleClose);

      myStoreToggleButton.removeEventListener('click', this.toggleButtonHandler);
      window.removeEventListener('click', this.clickOutsideHandler, true);
    },
    methods: {
      toggle() {
        this.open = !this.open;
        setGlobalMyStoreOpen(this.open);
      },
      handleClose(escKeyPressed) {
        this.open = false;
        setGlobalMyStoreOpen(this.open);
        document.querySelector('#my-store-sr-only').textContent = 'Open select my store';
        myStoreToggleButton.setAttribute('aria-expanded', 'false');
        navbarWrapper.style.overflowY = 'initial';
        const isFocusOnBody = document.activeElement.tagName === 'BODY';
        if (isFocusOnBody || escKeyPressed) { myStoreToggleButton.focus(); }

        if (isWhiteNav) {
          gNav.setAttribute('data-my-store', 'false');
          document.body.classList.remove('no-scroll');
        }
      },
      toggleButtonHandler(event) {
        if (!isWhiteNav) {
          event.preventDefault();
          event.stopPropagation();
        }

        const { clientWidth } = window.document.body;

        this.toggle();
        document.body.classList.remove('sign-in-open');
        document.querySelector('#my-store-sr-only').textContent = `${this.open ? 'Close' : 'Open'} select my store`;
        myStoreToggleButton.setAttribute('aria-expanded', this.open ? 'true' : 'false');
        navbarWrapper.style.overflowY = this.open && clientWidth < 992 ? 'hidden' : 'initial';
        storesDropdown.style.display = this.open ? 'block' : 'none';

        if (isWhiteNav) {
          gNav.setAttribute('data-my-store', this.open ? 'true' : 'false');

          if (this.open) {
            document.body.classList.add('no-scroll');
          } else {
            document.body.classList.remove('no-scroll');
          }
        }
      },
      clickOutsideHandler(event) {
        // Avoid closing component if user clicked on any of those elements
        const excludeElements = [
          'change-store-button',
          'set-store',
          'store-details-closed',
          'edit-location-link',
          'store-details-closed',
          'site-header-action-local',
        ];

        if (!this.open || excludeElements.includes(event.target.getAttribute('data-ui')) || myStoreToggleButton.contains(event.target)) return;

        if (!storesDropdown.contains(event.target)) {
          eventBus.$emit('closed');
        }
      },
    },
    render: (app) => app(MyStore, {
      props: {
        fetchSuggestedStore: isWhiteNav,
        open: data.open,
        customClasses: ['my-store-wrapper'],
        trapTabInsideWidget: true,
      },
      on: {
        'set-store': function (store) {
          eventBus.$emit('update-store', store);
        },
        closed() {
          eventBus.$emit('closed');
        },
        'on-escape': function () {
          eventBus.$emit('closed', 'escape key was pressed');
        },
        'suggested-store': function (store) {
          eventBus.$emit('suggested-store', { ...store, isSuggestion: true });
        },
      },
    }),
  });
};

if (myStoreToggleButton && navbarWrapper) {
  if (isWhiteNav) {
    myStoreToggleButton.parentNode.removeAttribute('data-visible');
  }

  ['focus', 'mouseenter'].forEach((eventName) => myStoreToggleButton.addEventListener(eventName, () => {
    if (!isMyStoreMounted) {
      mountMyStore();
    }
  }, {
    once: true,
  }));

  window.addEventListener('load', () => {
    if (!isMyStoreMounted) {
      mountMyStore();
    }
  });
}
